/** Kind of a flattened pivot row item. */
export enum PivotRowKindEnum {
  Leaf = 'Leaf',
  Group = 'Group',
  Subtotal = 'Subtotal',
}
